import { Sidebar } from './sidebar'
import { MobileSidebar } from './mobile-sidebar'
import { Header } from './header'
import { useUIStore } from '@/stores/ui-store'

interface MainLayoutProps {
  title: string
  children: React.ReactNode
}

export function MainLayout({ title, children }: MainLayoutProps) {
  const { sidebarCollapsed, toggleSidebar, mobileSidebarOpen, toggleMobileSidebar } = useUIStore()

  return (
    <div className="h-screen overflow-hidden bg-background text-foreground flex">
      {/* Desktop Sidebar */}
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={toggleSidebar}
      />

      {/* Mobile Sidebar Drawer */}
      <MobileSidebar
        open={mobileSidebarOpen}
        onClose={toggleMobileSidebar}
      />

      {/* Main Content */}
      {/*
        `min-w-0` NÃO É ENFEITE: filho de flex tem `min-width: auto` e não
        encolhe abaixo do próprio conteúdo. Sem ele, uma tabela larga empurra
        este contêiner para fora da viewport e o `overflow-hidden` corta o que
        passou — foi o que a validação visual do PR #601 pegou no tablet, com
        as colunas de duração e custo sumindo pela direita em vez de rolarem.
      */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Header */}
        <Header
          title={title}
          onToggleSidebar={toggleMobileSidebar}
        />

        {/* Content Area */}
        <main className="flex-1 overflow-auto p-6 scrollbar-thin min-w-0">
          <div className="animate-fade-in min-w-0">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
